const PUBLIC_ROUTE_PREFIXES = [
    '/create-account',
    '/login',
    '/forgot-password',
    '/reset-password',
    '/verify-email',
    '/r/',
    '/teacher/invitation',
    '/invite/accept',
] as const;

export const isPublicRoute = (pathname: string): boolean =>
    PUBLIC_ROUTE_PREFIXES.some((prefix) =>
        prefix.endsWith('/')
            ? pathname.startsWith(prefix) || pathname === prefix.slice(0, -1)
            : pathname === prefix || pathname.startsWith(`${prefix}/`),
    );
